import React from "react";
import {CardContent, CardHeader, Button, CardActions} from "@mui/material";
import {useState} from "react";
import {useDispatch} from "react-redux";
import DialogContentText from "@mui/material/DialogContentText";
import {setModal} from "../../../../Common/App";
import {DialogCard} from "../../../../../Components/Cards/DialogCard";
import {Alert, Loader} from "../../../../../Components";
import {resendInvitation} from "../../index";

export const ResendInvitationModal = ({userId, userName}) => {

    const dispatch = useDispatch();
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("info");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        setIsLoading(true);
        setMessage('');
        await resendInvitation({dispatch, userId}).then((res) => {
            if(res.success){
                dispatch(setModal({component:null, open:false}));
            }
            setIsLoading(false);
            setMessage(res.message);
            setStatus(res.status);
        });
    };

    return(
        <DialogCard>
            <CardHeader
                title={`Resend Invitation - ${userName}`}
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                {message && (
                    <Alert severity={status} sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                )}
                <DialogContentText sx={{ mb: 2 }}>
                    Are you sure you want to resend the password setup invitation to <strong>{userName}</strong>? A new invitation email will be sent to their registered email address.
                </DialogContentText>
            </CardContent>
            <CardActions>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color={'primary'} onClick={ handleSubmit }>Resend Invitation</Button>
            </CardActions>
        </DialogCard>
    )
}

